import { CLEAR_PAGE } from '../base/types';
import { DELETE_SEO_PAGES, FETCH_SEO_PAGES } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const seoReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_SEO_PAGES}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_SEO_PAGES}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_SEO_PAGES}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case `${DELETE_SEO_PAGES}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => i.slug !== payload?.slug),
      };

    case CLEAR_PAGE:
      return payload === 'seo' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default seoReducer;
